import axios from "axios";
import apiurl from "../config/api";

export function editGroup(groupInfo) {
  return axios.post(apiurl.clientEditGroupUrl, groupInfo).then((result) => {
    return result.data.data;
  });
}
